var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{staticStyle:{"min-width":"12rem"},attrs:{"options":_vm.classList,"selected":_vm.filteredClass,"title":'Class'},on:{"updateOption":_vm.updateFilteredClass}})
}
var staticRenderFns = []

export { render, staticRenderFns }